import { CardRarity } from "../../../models/CardRarity";
import { CardVariant } from "../../../models/CardVariant";
import { IFilterCommand } from "../IFilterCommand";

export type RarityFilterArgs = {
    rarities: CardRarity[] | null | undefined
}

export class RarityFilter<TItem extends CardVariant> implements IFilterCommand<TItem, RarityFilterArgs> {
    isMatch(item: TItem, args: RarityFilterArgs = { rarities: undefined }): boolean {
        // No rarity provided, which means we're not filtering on rarity.
        if (!args.rarities?.length) {
            return true;
        }

        if (item.altRarity) {
            return args.rarities.includes(item.altRarity);
        }

        if (!item.card.rarity) {
            return false;
        }

        return args.rarities.includes(item.card.rarity);
    }
}